import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import tema from "./tema";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: tema,
  },
});
